import qs from 'qs'
import axiosClient from '../axiosClient'
import { WaterEngine } from '@/types/waterEngine'

const waterEngineApi = {
  getDetail(interfaceId: number): Promise<{ data: WaterEngine }> {
    const url = `/api/waterengine/${interfaceId}`
    return axiosClient.get(url)
  },
}

export default waterEngineApi
